import { render, staticRenderFns } from "./barndLlist.vue?vue&type=template&id=423d73b2&scoped=true"
import script from "./barndLlist.vue?vue&type=script&lang=js"
export * from "./barndLlist.vue?vue&type=script&lang=js"
import style0 from "./barndLlist.vue?vue&type=style&index=0&id=423d73b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d73b2",
  null
  
)

export default component.exports